import React, { useMemo, useState } from "react";
import { View, StyleSheet, TextInput } from "react-native";
import NtMaterialIcon from "./NtMaterialIcon";
import NtTouchableEffect from "./NtTouchableEffect";
import { useTheme } from "../context/ThemeContext";

/**
 * Themed text input. Backward-compatible signature; defaults pull from theme.
 *
 * Props:
 *   showEye, icon, width, bgColor, textColor, borderColor, containerStyle,
 *   renderAction, ...TextInput props
 */
function NtTextInput({
  showEye = false,
  icon,
  width = "100%",
  bgColor,
  textColor,
  borderColor,
  containerStyle,
  renderAction,
  ...otherProps
}) {
  const { theme } = useTheme();
  const [secureEntry, setSecureEntry] = useState(otherProps?.secureTextEntry);
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const bg = bgColor ?? theme.surface2;
  const fg = textColor ?? theme.text;
  const bd = borderColor ?? theme.borderSoft;

  return (
    <View
      style={[
        styles.container,
        { width, backgroundColor: bg, borderColor: bd },
        containerStyle,
      ]}
    >
      {icon && (
        <NtMaterialIcon
          style={styles.icon}
          name={icon}
          size={18}
          color={theme.textDim}
        />
      )}
      <TextInput
        placeholderTextColor={theme.textMute}
        style={[styles.text, { color: fg }]}
        {...otherProps}
        secureTextEntry={secureEntry}
      />
      {showEye && (
        <NtTouchableEffect
          style={{ position: "absolute", right: 10 }}
          onPress={() => setSecureEntry(!secureEntry)}
        >
          <NtMaterialIcon
            name={!secureEntry ? "eye" : "eye-off"}
            color={theme.textDim}
            size={20}
          />
        </NtTouchableEffect>
      )}
      {renderAction && renderAction}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      borderRadius: t.radius,
      flexDirection: "row",
      paddingVertical: 8,
      paddingHorizontal: 12,
      alignItems: "center",
      borderWidth: 1,
    },
    text: {
      flex: 1,
      fontSize: 13,
      paddingVertical: 0,
      marginLeft: 6,
      outlineStyle: "none",
    },
    icon: {},
  });

export default NtTextInput;
